import { format, formatDistanceToNow, parse } from 'date-fns'
import { fromZonedTime } from 'date-fns-tz'
import {
  DATE_AND_TIME_FORMAT_STRING,
  DATE_FORMAT_STRING,
  NOTIFICATION_SENT_AT_FORMAT,
} from 'helpers/timeAndDateHelpers/constants'

/**
 * A function that converts a timestamp from local time to UTC
 * @param timestamp - The timestamp to be converted to UTC
 * @param timezone - The initial timezone of the property where the timestamp is created
 * @returns - The timestamp converted to UTC
 */
export const formatTimestampUTC = (timestamp: string, timezone: string) => {
  // Parse the timestamp in the given timezone
  const date = parse(
    timestamp,
    DATE_AND_TIME_FORMAT_STRING.MM_dd_yyyy_hh_mm_a,
    new Date(),
  )

  // Convert the parsed date to UTC
  const utcDate = fromZonedTime(date, timezone)

  // Format the UTC date as an ISO string
  return utcDate.toISOString()
}

/**
 * Format Datestamp (DS)
 * Helper function for formatting datestamp in format YYYY-MM-DD
 * This format should be used when sending dates in requests
 * @param date
 * @returns date in YYYY-MM-DD format
 */
export const formatDS = (date: Date) => {
  return format(date, DATE_FORMAT_STRING.yyyy_MM_dd)
}

export const dateFromNow = (
  date: string | Date,
  format: string = NOTIFICATION_SENT_AT_FORMAT,
  addSuffix: boolean = true,
) => {
  let parsedDate: Date

  if (typeof date === 'string') {
    parsedDate = parse(date, format, new Date())
  } else {
    parsedDate = date
  }

  return formatDistanceToNow(parsedDate, { addSuffix })
}

// Helper function to get user's timezone
export const getUserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}
